module.exports = __webpack_public_path__ + "images/apps/lanhu-bad558a69c81072e0b1ea586c1239d08.png";